import { IObject } from "@quest/base-core";
import { Model } from "@quest/platform-murka-phase_2/dist";

export class GameParserModel extends Model {
  private reelsSets: any;
  private specialSymbolData: IObject[];
  private specialSymbolStatus: boolean;
  // private mysterySymbolId: number; // Mystery Symbol 77 Replace ID
  private specialMysterySymbolsData: IObject[];
  private collectMeterParseData: IObject[];
  private collectMeterData: IObject[];
  private collectLimitData: IObject[];
  private bannerCounter: number = 1;
  private isCascadingDone: boolean = false;
  private fgBottomBarWin: number = 0;
  private fgCascadeWin: number = 0;
  private cascadeTotalWin: number = 0;
  private cascadeResponse: any;
  private cascadingCount: number = 1;
  private cascadeWin: number = 0;
  private cascadeAccumuWin: number = 0;
  private baseGameStops: number[];
  private freeGameStops: number[];
  private currentCascadingReelNumber: number = 0;
  private baseGameReelGridForStack: number[][];
  private cascadeIndexNumber: number = 0;
  private totalCascadeIndexNumber: number = 0;
  private symBounds: any;
  private moneyHuntingBasegameWin:number = 0;
  private totalMoneyHuntingSpin:number = 0;
  private caseCadeLineToggleCount: number;
  private clueInfo:any;
  private clueRevealedFeatureStatus:boolean = false;
  private clueRevealedInfo:any;
  private currentClueLevel:number = 0;
  private cascadeOffsets: number[][][] = [
    [
      [0, 0],
      [0, 1],
      [0, 2],
      [0, 3],
      [0, 4],
      [0, 5],
      [0, 6],
      [1, 0],
      [1, 1],
      [1, 2],
      [1, 3],
      [1, 4],
      [1, 5],
      [1, 6],
      [2, 0],
      [2, 1],
      [2, 2],
      [2, 3],
      [2, 4],
      [2, 5],
      [2, 6],
      [3, 0],
      [3, 1],
      [3, 2],
      [3, 3],
      [3, 4],
      [3, 5],
      [3, 6],
      [4, 0],
      [4, 1],
      [4, 2],
      [4, 3],
      [4, 4],
      [4, 5],
      [4, 6],
    ],
  ];
  private baseGameReelSet: number[][];
  private freeGameReelSet: number[][];
  private allReelSet: { [key: string]: number[][] };
  private moneyHuntingFetureStatus: boolean = false;
  private stikcyFramesOffsets: number[][] = [];
  private stikcyFramesRawData: number[] = [];
  private stickyFramesDataFG: number[][] = [];
  private moneyHuntingRewardDetails: any[] = [];
  private moneyHuntingTotalWin: number = 0;
  private spotlightPosition: number[] = [];
  public setIsFreeSpintriggered(value: boolean) {
    this.freeSpinTrigger = value;
  }
  setReelSets(value: any): void {
    this.reelsSets = value;
  }
  getReelSets(value: string): any {
    return this.reelsSets[value];
  }
  public setMoneyHuntingFetureStatus(value: any): void {
    this.moneyHuntingFetureStatus = value;
  }
  public getMoneyHuntingFetureStatus(): any {
    return this.moneyHuntingFetureStatus;
  }
  public setSpotlightPosition(value: number[]): void {
    this.spotlightPosition = value;
  }
  public getSpotlightPosition(): number[] {
    return this.spotlightPosition;
  }
  public setStikcyFramesOffsets(value: number[][]): void {
    this.stikcyFramesOffsets = value;
  }
  public getStikcyFramesOffsets(): number[][] {
    return this.stikcyFramesOffsets;
  }

  public setStickyFramesPosition(data: number[][]) {
    this.stickyFramesDataFG = data;
  }
  public getStickyFramesPosition(): number[][] {
    const uniqueArray = [...new Set(this.stickyFramesDataFG)];
    return uniqueArray;
  }

  public setStikcyFramesRawData(value: number[]): void {
    this.stikcyFramesRawData = value;
  }
  public getStikcyFramesRawData(): number[] {
    return this.stikcyFramesRawData;
  }

  //to store all reel sets
  public setAllReelSet(value: { [key: string]: number[][] }): void {
    this.allReelSet = value;
  }
  public getAllReelSet(reelSet: string): number[][] {
    return this.allReelSet[reelSet];
  }


  public setCascadeNumber(data: number): void {
    this.cascadeIndexNumber = data;
  }
  public getCascadeNumber(): number {
    return this.cascadeIndexNumber;
  }
  public setTotalCascadeNumber(data: number): void {
    this.totalCascadeIndexNumber = data;
  }
  public getTotalCascadeNumber(): number {
    return this.totalCascadeIndexNumber;
  }

  /**
   * This method returns base game reelset with stack
   */
  public getBaseGameReelSetWithStack(): number[][] {
    return this.baseGameReelSet;
  }

  public setBaseGameReelSetWithStack(value: number[][]): void {
    this.baseGameReelSet = value;
  }

  /**
   * Add to get base game reel grid for stack
   */
  public getBaseGameGridForStack(): number[][] {
    return this.baseGameReelGridForStack;
  }

  /**
   * Add to set base game reel grid for stack
   */
  public setBaseGameGridForStack(value: number[][]): void {
    this.baseGameReelGridForStack = value;
  }

  /**
   * This model will return cascade status
   * @returns
   */
  public getCurrentCascadingReelNumber(): number {
    return this.currentCascadingReelNumber;
  }

  /**
   * This model will set cascade status
   * @returns
   */
  public setCurrentCascadingReelNumber(value: number): void {
    this.currentCascadingReelNumber = value;
  }

  /**
   * Method returns basegame reel stops
   */
  public getBaseGameStops(): number[] {
    return this.baseGameStops;
  }
  public setBaseGameStops(value: number[]): void {
    this.baseGameStops = value;
  }

  /**
   * This model will return cascade offsets
   * @returns
   */
  public getCascadeOffsets(): number[][][] {
    return this.cascadeOffsets;
  }

  /**
   * This model will set cascade offsets
   * @returns
   */
  public setCascadeOffsets(value: number[][][]): void {
    this.cascadeOffsets = value;
  }

  /**
   * This model will return cascade offsets
   * @returns
   */
  public getCascadeWin(): any {
    return this.cascadeWin;
  }

  /**
   * This model will set cascade offsets
   * @returns
   */
  public setCascadeWin(value: any): void {
    this.cascadeWin = value;
  }

  /**
   * This model will return cascade accumulated win
   * @returns
   */
  public getCascadeAccumulatedWin(): any {
    return this.cascadeAccumuWin;
  }

  /**
   * This model will set cascade accumulated win
   * @returns
   */
  public setCascadeAccumulatedWin(value: any): void {
    this.cascadeAccumuWin = value;
  }

  /**
   * This model will return cascade frequencey
   * @returns
   */
  public getCascadingCount(): number {
    return this.cascadingCount;
  }

  /**
   * This model will set cascade frequencey
   * @returns
   */
  public setCascadingCount(value: number): void {
    this.cascadingCount = value;
  }

  /**
   * store cascade consolodated spin response
   */
  public getCascadeResponse(): any {
    return this.cascadeResponse;
  }
  public setCascadeResponse(value: any): void {
    this.cascadeResponse = value;
  }

  /**
   * This model will return cascade offsets
   */
  public getCascadeTotalWin(): any {
    return this.cascadeTotalWin;
  }
  /**
   * This model will set cascade offsets
   */
  public setCascadeTotalWin(value: any): void {
    this.cascadeTotalWin = value;
  }

  /**
   * Method returns total cascade win
   */
  public getTotalCascadeWin(): number {
    return this.fgBottomBarWin;
  }
  public setTotalCascadeWin(value: number): void {
    this.fgBottomBarWin = value;
  }

  /**
   * This model will return cascade status
   * @returns
   */
  public getCascadingStatus(): boolean {
    return this.isCascadingDone;
  }

  /**
   * This model will set cascade status
   * @returns
   */
  public setCascadingStatus(value: boolean): void {
    this.isCascadingDone = value;
  }

  /**
   * Method to save Mysrery Symbol 78 replaced Ids
   * @param data
   */
  public setSpecialMysterySymbolsData(data: IObject[]) {
    this.specialMysterySymbolsData = data;
  }

  /**
   * Method to return Mysrery Symbol 78 replaced Ids
   * @param data
   */
  public getSpecialMysterySymbolsData(): IObject[] {
    return this.specialMysterySymbolsData;
  }

  /**
   * Method returns freegame reel stops
   */
  public getFreeGameStops(): number[] {
    return this.freeGameStops;
  }
  public setFreeGameStops(value: number[]): void {
    this.freeGameStops = value;
  }

  // Set & Get for winning symbols bounds
  public setWinSymBounds(value: any): void {
    this.symBounds = value;
  }

  public getWinSymBounds(): any {
    return this.symBounds;
  }

  /**
   * Method to save cascade line toggle count.
   * @param Number
   */
  public setCascadeLineToggleCount(data: number) {
    this.caseCadeLineToggleCount = data;
  }

  /**
   * Method to return cascade line toggle count.
   * @returns Number
   */
  public getCascadeLineToggleCount(): number {
    return this.caseCadeLineToggleCount;
  }
  /**
   * Method to save Mysrery Symbol 78 replaced Ids
   * @param data
   */
  public setCollectMeterParseData(data: IObject[]) {
    this.collectMeterParseData = data;
  }

  /**
   * Method to return Mysrery Symbol 78 replaced Ids
   * @param data
   */
  public getCollectMeterParseData(): IObject[] {
    return this.collectMeterParseData;
  }
  /**
  * Setter method to set special symbol status.
  * @param data 
  */
  public setSpecialSymbolData(data: IObject[]): void {
    this.specialSymbolData = data;
  }

  /**
   * Getter method to set special symbol status.
   * @param data 
   */
  public getSpecialSymbolData(): IObject[] {
    return this.specialSymbolData
  }
  /**
   * Setter method to set special symbol status.
   * @param data 
   */
  public setIsSpecialSymbol(data: boolean): void {
    this.specialSymbolStatus = data;
  }

  /**
   * Getter method to set special symbol status.
   * @param data 
   */
  public getIsSpecialSymbol(): boolean {
    return this.specialSymbolStatus
  }
  /**
  * Setter method to set collect meter data.
  * @param data 
  */
  public setCollectMeterData(data: IObject[]): void {
    this.collectMeterData = data;
  }

  /**
   * Getter method to get collect meter data.
   * @param data 
   */
  public getCollectMeterData(): IObject[] {
    return this.collectMeterData
  }
  /**
  * Setter method to set collect meter data.
  * @param data 
  */
  public setCollectLimitData(data: IObject[]): void {
    this.collectLimitData = data;
  }

  /**
   * Getter method to get collect meter data.
   * @param data 
   */
  public getCollectLimitData(): IObject[] {
    return this.collectLimitData
  }

  /**
   * This method returns free game reelset with stack
   */
  public getFreeGameReelSetWithStack(): number[][] {
    return this.freeGameReelSet;
  }

  public setFreeGameReelSetWithStack(value: number[][]): void {
    this.freeGameReelSet = value;
  }
  /**
 * Setter method to set collect meter data.
 * @param data 
 */
  public setBannerCounter(data: number): void {
    this.bannerCounter = data;
  }

  /**
   * Getter method to get collect meter data.
   * @param data 
   */
  public getBannerCounter(): number {
    return this.bannerCounter
  }

  public setMoneyHuntingRewardsDetails(value: any[]): void {
    this.moneyHuntingRewardDetails = value;
  }
  public getMoneyHuntingRewardsDetails(): any[] {
    return this.moneyHuntingRewardDetails;
  }

  public setMoneyHuntingTotalWin(value: number): void {
    this.moneyHuntingTotalWin = value;
  }
  public getMoneyHuntingTotalWin(): number {
    return this.moneyHuntingTotalWin;
  }

  private moneyRewardSpins:any;
  public setMoneyRewardSpins(value: any): void {
    this.moneyRewardSpins = value;
  }
  public getMoneyRewardSpins(): any {
    return this.moneyRewardSpins;
  }
  private moneyRewardSpinsCounter:any;
  public setMoneyRewardSpinsCounter(value: any): void {
    this.moneyRewardSpinsCounter = value;
  }
  public getMoneyRewardSpinsCounter(): any {
    return this.moneyRewardSpinsCounter;
  }
  private prizeCoinPositions:any;
  public setPrizeCoinPositions(value: any): void {
    this.prizeCoinPositions = value;
  }
  public getPrizeCoinPositions(): any {
    return this.prizeCoinPositions;
  }
  private collectPosition:any;
  public setCollectPosition(value: any): void {
    this.collectPosition = value;
  }
  public getCollectPosition(): any {
    return this.collectPosition;
  }
  private preCollectMeterData:any;
  public setPreCollectMeterData(value: any): void {
    this.preCollectMeterData = value;
  }
  public getPreCollectMeterData(): any {
    return this.preCollectMeterData;
  }
  private PreCollectMeterLimitData:any;
  public setPreCollectMeterLimitData(value: any): void {
    this.PreCollectMeterLimitData = value;
  }
  public getPreCollectMeterLimitData(): any {
    return this.PreCollectMeterLimitData;
  }
  private IsGrandJPAvailable:any = false;
  public setIsGrandJPAvailable(value: any): void {
    this.IsGrandJPAvailable = value;
  }
  public getIsGrandJPAvailable(): any {
    return this.IsGrandJPAvailable;
  }
  private IsGrandJPPrize:any = false;
  public setIsGrandJPPrize(value: any): void {
    this.IsGrandJPPrize = value;
  }
  public getIsGrandJPPrize(): any {
    return this.IsGrandJPPrize;
  }
  private GameTotalWinAmt:any = false;
  public setGameTotalWinAmt(value: any): void {
    this.GameTotalWinAmt = value;
  }
  public getGameTotalWinAmt(): any {
    return this.GameTotalWinAmt;
  }
   /**
   * Method returns total fg cascade win
   */
  public getTotalFgCascadeWin(): number {
    return this.fgCascadeWin;
  }
  public setTotalFgCascadeWin(value: number): void {
    this.fgCascadeWin = value;
  }

  public setMoneyAndClueBasegameWin(value:number):void{
    this.moneyHuntingBasegameWin = value;
  }
  public getMoneyAndClueBasegameWin():number{
    return this.moneyHuntingBasegameWin;
  }

  public settotalMoneyHuntingSpin(value:number):void{
    this.totalMoneyHuntingSpin = value;
  }
  public gettotalMoneyHuntingSpin():number{
    return this.totalMoneyHuntingSpin;
  }

  
  public setclueInfo(value:any):void{
    this.clueInfo = value;
  }
  public getclueInfo():any{
    return this.clueInfo;
  }
  private TotalClueCount:any
  public setTotalClueCount(value:any):void{
    this.TotalClueCount = value;
  }
  public getTotalClueCount():any{
    return this.TotalClueCount;
  }

   public setClueRevealedFeatureStatus(value:boolean):void{
    this.clueRevealedFeatureStatus = value;
  }
  public getClueRevealedFeatureStatus():boolean{
    return this.clueRevealedFeatureStatus;
  }
  public setclueRevealedInfo(value:any):void{
    this.clueRevealedInfo = value;
  }
  public getclueRevealedInfo():any{
    return this.clueRevealedInfo;
  }
  public setCurrentClueLevel(value:number):void{
    this.currentClueLevel = value;
  }
  public getCurrentClueLevel():number{
    return this.currentClueLevel;
  }

  public setBalance(value: number): void {
    super.setBalance(Number(value));
  }
  public setFreeBalance(value: number): void {
    super.setFreeBalance(Number(value));
  }
  public setCurrentWin(value: number): void {
    super.setCurrentWin(Number(value));
  }
  public setTotalWin(value: number): void {
    super.setTotalWin(Number(value));
  }
  public setGameWinAmt(value: number): void {
    super.setGameWinAmt(Number(value));
  }
  public setCurrentSpinTotalWinAmt(value: number): void {
    super.setCurrentSpinTotalWinAmt(Number(value));
  }

   public setTotalBet(value:number):void {
        this.totalBet =Number(value.toFixed(2));
    }

  private lastCascadeGridForFg: number[][];
  
  public setLastCascadeGridForFg(value: number[][]): void {
    this.lastCascadeGridForFg = value;
  }

  public getLastCascadeGridForFg(): number[][] {
    return this.lastCascadeGridForFg;
  }
  private clueRevealedWinAmt: number = 0;
  
  public setclueRevealedWinAmt(value: number): void {
    this.clueRevealedWinAmt = value;
  }

  public getclueRevealedWinAmt(): number {
    return this.clueRevealedWinAmt;
  }
  private previousFreeSpinWinAmt: number = 0;
  
  public setCurrentlyProcessingFSAmt(value: number): void {
    this.previousFreeSpinWinAmt = value;
  }

  public getCurrentlyProcessingFSAmt(): number {
    return this.previousFreeSpinWinAmt;
  }
  
}
